<h1 mat-dialog-title>{{ "select_api_popup.select_api" | translate }}</h1>

<mat-dialog-content>
  <form id="selectApiPopup" class="container" [formGroup]="form">
    <div
      fxFlex
      fxLayout="column"
      fxLayoutGap="20px grid"
      fxLayout.sm="column"
      class="u-padding-bottom-15"
    >
      <div class="content-container">
        <mat-radio-group
          id="matSelectApigrp"
          aria-label="Select an option"
          formControlName="selectApi"
        >
          <mat-radio-button
            [disabled]="option.isDisabled"
            [checked]="option.isDisabled"
            type="radio"
            *ngFor="let option of selectApiOptions"
            [value]="option.value"
            id="{{'selectApi'+option.id}}"
          >
            {{option.name}}
          </mat-radio-button>
        </mat-radio-group>
        <mat-error
          id="selectApiRequired"
          class="error-message"
          *ngIf="
        (form.get('selectApi').dirty ||
        form.get('selectApi').touched) && form.get('selectApi').hasError('required')
        "
        >
          {{ "select_api_popup.select_api_required" | translate }}
        </mat-error>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button id="btnSave" mat-flat-button color="primary" (click)="save()">
    {{ "select_api_popup.ok" | translate }}
  </button>
  <button id="btnClose" mat-flat-button color="warn" mat-dialog-close>
    {{ "select_api_popup.cancel" | translate }}
  </button>
</mat-dialog-actions>
